export enum NotificationTypeEnum {
  UPLOAD_UPLOADED = "upload_uploaded",
  OFFER_ALERT_ALERT = "offer_alert_alert",
  OFFER_ALERT_EXPIRED = "offer_alert_expired",
  OFFER_REQUEST_REQUESTED = "offer_request_requested",
  OFFER_REQUEST_CHANGED = "offer_request_changed",
  ORDER_REQUESTED = "order_requested",
  ORDER_CHANGED = "order_changed",
  CHAT_MESSAGE_USER_ORGANISATION_CREATED = "chat_organisation_user_organisation_created",
  EXPORT_CREATED = "export_created",
}
